/*
 * Define a form page to allow a user to enter mulitline text.
 */
import * as yup from 'yup'
import { stringYupOptional, stringYupRequired } from '../validators'
import { requiredMessage } from '../strings/messages'

export const multilineTextPage = propOverrides => {
  const props = {
    pageId: 'needed_page',
    fieldName: 'needed',
    required: false,
    requiredMessage: requiredMessage,
    maxLength: 2000,
    displayCharsRemaining: true,
    lengthMessage: 'too long',
    rows: 8,
    label: 'needed',
    hint: '',
    labelClassName: 'needed',
    ...propOverrides
  }

  return {
    id: props.pageId,
    validation:
      props.validation ||
      yup.object().shape({
        [props.fieldName]: props.required
          ? stringYupRequired(
              props.requiredMessage,
              props.maxLength,
              props.lengthMessage
            )
          : stringYupOptional(props.maxLength, props.lengthMessage)
      }),
    fields: [
      {
        type: 'text',
        name: props.fieldName,
        label: props.label,
        labelClassName: props.labelClassName,
        hint: props.hint,
        multiline: true,
        rows: props.rows,
        maxLength: props.maxLength,
        displayCharsRemaining: props.displayCharsRemaining
      }
    ]
  }
}
